import React from "react";
import {
  List,
  Show,
  ShowButton,
  SimpleShowLayout,
  Datagrid,
  TextField,
  Filter,
  TextInput,
  ReferenceInput,
  SelectInput,
  ReferenceField,
  DateField
} from "admin-on-rest/lib/mui";

import ShowPie from "./custom/ShowPie";
import CreatePdf from "./custom/CreatePdf";

export const AnwserFilter = props => (
  <Filter {...props}>
    <ReferenceInput
      label="Quiz Box"
      source="surveyID"
      reference="survey"
      allowEmpty
      alwaysOn
    >
      <SelectInput optionText={choice => `${choice.title}`} />
    </ReferenceInput>
    <SelectInput
      alwaysOn
      allowEmpty
      label="resources.gender.name"
      source="gender"
      choices={[
        { id: "Άντρας", name: "Άντρας" },
        { id: "Γυναίκα", name: "Γυναίκα" },
        { id: "Άλλο", name: "Άλλο" }
      ]}
    />
    <SelectInput
      alwaysOn
      allowEmpty
      label="resources.age.name"
      source="age"
      choices={[
        { id: "18-24", name: "18-24" },
        { id: "25-34", name: "25-34" },
        { id: "35-44", name: "35-44" },
        { id: "45-54", name: "45-54" },
        { id: "55-64", name: "55-64" },
        { id: "65+", name: "65+" }
      ]}
    />
  </Filter>
);

export const AnswerList = props => (
  <List {...props} filters={<AnwserFilter />} title="Quiz box">
    <Datagrid key={props._id}>
      <TextField label="resources.title.name" source="surveyID.title" />
      <DateField
        label="resources.expiration_day.name"
        source="surveyID.ends_on"
      />
      <ReferenceField
        linkType="none"
        label="resources.companies.name"
        source="surveyID.CompanyID"
        reference="companies"
      >
        <TextField source="name" />
      </ReferenceField>
      <ReferenceField
        linkType="none"
        label="resources.branches.name"
        source="surveyID.BranchID"
        reference="branches"
      >
        <TextField source="address" />
      </ReferenceField>
      <TextField label="resources.count_votes.name" source="surveyID.limit" />
      <TextField label="resources.percentage.name" source="perce" />
      <ShowButton />
    </Datagrid>
  </List>
);

class Title extends React.Component {
  state = {
    styles: {
      // position: 'fixed',
      // background: 'rgb(0, 188, 212)',
      // padding: '20px',
      // zIndex: '1000',
      // fontSize: '30px',
      // fontWeight: '900',
      // color: '#fff',
      // left: '50%',
      // top: "110px",
    }
  }
  render() {
    const { surveyID } = this.props.record;
    const { styles } = this.state;
    return <div style={styles}></div>
  }
}

export const AnswerShow = props => {
  // console.log("props",props);
  return (
    <div  id="all-answers" >
      <Show {...props} title="resources.answer_survey.name" >
        <SimpleShowLayout >
          <Title />
          <ShowPie source="surveyID.results" />
        </SimpleShowLayout>
      </Show>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/pages/answer.js